import { createActions } from 'redux-actions';

export const actions = createActions({
  PRESENTATION: {
    GENERATE_PRESENTATION: (payload) => payload,
    EXPORT_INVESTMENT_STRATEGY: (payload) => payload,
    SET_ENABLED_STRATEGIES: (payload) => payload,
  },
}).presentation;
